import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { EcommerceInfo } from '../modal';

export default function reducer(state: EcommerceInfo = new EcommerceInfo(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.ECOMMERCE_INFO_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.ECOMMERCE_INFO_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.ECOMMERCE_INFO_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
